import{useChatState as o}from"./use-chat-state.hook.js";const t=()=>{const t=o();return(null==t?void 0:t.unreadCount)||0};export{t as useChatUnreadCount};